import { render } from "./object-help-email.vue?vue&type=template&id=6aa8d0c1"
import script from "./object-help-email.vue?vue&type=script&lang=js"
export * from "./object-help-email.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__